import {DEPOSIT_SUCCESS, DEPOSIT_ERROR} from '../actions/deposit';

const initialState = {
    data: '',
    error: null
};

export default function reducer(state = initialState, action) {
    if (action.type === DEPOSIT_SUCCESS) {
        return Object.assign({}, state, {
            data: action.data,
            error: null
        });
    } else if (action.type === DEPOSIT_ERROR) {
        return Object.assign({}, state, {
            error: action.error
        });
    }
    return state;
}